import React from 'react';

const Input = ({ label, error, containerClass, bgColor, ...props }) => {
  return (
    <div className={containerClass}>
      {label && <label className="xs:text-sm md:text-lg">{label}</label>}
      <input
        className={
          error
            ? `placeholder:italic placeholder:text-slate-400 border border-gray-300 block w-full h-12 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:border-red-500 focus:ring-red-500 focus:ring-1 sm:text-sm mt-2 ${bgColor}`
            : `placeholder:italic placeholder:text-slate-400 border border-gray-300 block w-full h-12 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:border-primary focus:ring-primary focus:ring-1 sm:text-sm mt-2 ${bgColor}`
        }
        {...props}
      />
      {error && <label className="xs:text-xs md:text-sm text-red-500">{error[0]}</label>}
    </div>
  );
};

export default Input;


